<template>
    <div class="exam-paper" ref="zj-add-exam-paper">
        <el-page-header :content="pageHeaderContent"  @back="gohomefunc" style="padding: 20px"/>
        <!-- 筛选项 -->
        <div class="step" data-number="1">完善试卷基本信息</div>
        <div class="e-condition xy-between flex-wrap" id="driver-add-paper-step-one">
            <div class="xy-center jf-start item">
                <div class="name">试卷名称</div>
                <el-input
                    v-model="paperInfo.name"
                    placeholder="请填写试卷名称"
                ></el-input>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">所属分类</div>
                <medical-class-selector
                    v-model="paperInfo.type"
                    :add-all="false"
                    @categories-load="updateOrganClass"
                ></medical-class-selector>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">用途</div>

                <el-select v-model="paperInfo.useFor" placeholder="请选择">
                    <el-option
                        v-for="item in useForData"
                        :key="item.value"
                        :value="item.value"
                        :label="item.name"
                    ></el-option>
                </el-select>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">总分</div>
                <el-input
                    v-model.number="paperInfo.totalScore"
                    :disabled="true"
                    type="number"
                    placeholder="总分自动计算"
                ></el-input>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">及格分</div>
                <el-input
                    v-model.number="paperInfo.passScore"
                    type="number"
                    @input="
                        (vl) => {
                            if (vl > paperInfo.totalScore) {
                                $message.warning('超过了试卷总分');
                            }
                        }
                    "
                ></el-input>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">权限</div>
                <el-select v-model="paperInfo.privilege" placeholder="请选择">
                    <el-option :value="1" label="机构公开"></el-option>
                    <el-option :value="2" label="平台公开"></el-option>
                </el-select>
            </div>
        </div>
        <!-- 试卷 -->
        <div class="e-paper xy-start al-str">
            <div class="que-type no-shrink" :class="{ border: !typeList.length }" id="driver-add-paper-step-two">
                <div class="step" data-number="2" style="background: #f4f5f6; padding: 12px 20px">选择题型，您可以选择多个题型</div>
                <div class="add-new-type xy-center">
                    <el-button type="primary" @click="addNewType" icon="el-icon-circle-plus-outline">新建题型
                    </el-button>
                </div>
                <div v-if="typeList.length" class="added-tp">
                    <type-box-mini
                        v-for="(box, index) in typeList"
                        :key="box.RankNum"
                        :type-box-data="box"
                        @delete-type="deleteType(index)"
                        @change-pos="changePosition"
                        @click="scrollTo(index)"
                    ></type-box-mini>
                </div>
            </div>
            <div class="auto-grow" :class="{ border: !typeList.length }">
                <type-box
                    choose-que-type-id="driver-add-paper-step-three"
                    v-for="(box, index) in typeList"
                    :key="box.uuid"
                    :box-data="box"
                    :id="'zj-add-exam-type-box' + index">
                    <div class="step" slot="chooseQueTypeFront"
                         v-if="index === 0"
                         data-number="3" style="background: #f4f5f6; padding: 12px 20px">
                        给已建题型配题
                        <i class="el-icon-right" style="margin-left: 4px; font-size: 16px; position: relative; top: 1px;"/>
                    </div>
                </type-box>
            </div>
        </div>

        <!-- 底部按钮 -->
        <div class="xy-center bottom-btn">
            <el-button
                type="primary"
                :disabled="disableBtn"
                :loading="flag.loading"
                @click="save">{{$route.query.type !== 'quickExam' ? '保存并返回' : '保存试卷'}}
            </el-button>
            <el-button
                v-if="$route.query.type !== 'quickExam'"
                type="primary"
                :loading="flag.loading"
                @click="goSave()"
                :disabled="disableBtn">保存
            </el-button>
            <el-button
                @click="handleBack">返回
            </el-button>
        </div>
    </div>
</template>

<script>
import TypeBox from "@/components/manager/resource/TypeBox.vue";
import TypeBoxMini from "@/components/manager/resource/TypeBoxMini.vue";
import { CommonPage } from "@/mixins/commonData";
import { createPaper } from "@/api/manage.js";
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import { uuid } from "@/utils";
import { scrollTop } from "@/utils/scrollHelper";
import { PaperManagerHelper } from "@/mixins/paperManageHelper";
import { SubjectType } from "@/kernel";
import start from "./addPaper-driver"
export default {
    mixins: [CommonPage, PaperManagerHelper],
    components: {
        TypeBox,
        TypeBoxMini,
        MedicalClassSelector
    },
    provide() {
        return {
            organClass: this.organClass
        }
    },
    data(vm) {
        vm.RankNum = 0
        return {
            paperInfo: {
                name: "",
                type: "",
                useFor: 1,
                totalScore: null,
                passScore: null,
                privilege: 1,
                subjectNum: 0
            },
            typeList: [],
            organClass: [],
            flag: {
                loading: false
            },
            keyIndex: 0,
        };
    },
    mounted() {
        this.addNewType()
        const isDriver = sessionStorage.getItem("isDriver")
        if (!(isDriver && JSON.parse(isDriver))) {
            this.$nextTick(() => {
                start()
                sessionStorage.setItem("isDriver", "true")
            })
        }
    },
    computed: {
        disableBtn() {
            let disable;
            for (let i in this.paperInfo) {
                if (["name", "totalScore", "passScore", "type"].includes(i)) {
                    if (!this.paperInfo[i]) {
                        disable = !this.paperInfo[i];
                        break;
                    } else {
                        disable = false;
                    }
                }
            }
            return disable;
        },
        pageHeaderContent() {
            const query = this.$route.query
            if (query.type === "quickExam") {
                return "自主组卷"
            }
            return "新增试卷"
        }
    },
    watch: {
        totalScore(score) {
            this.paperInfo.totalScore = score;
        },
        subjectNum(num) {
            this.paperInfo.subjectNum = num
        }
    },
    methods: {
        gohomefunc() {
            const type = this.$route.query.type
            if (type === 'quickExam') {
                this.$confirm('返回上一级将不保留该页面数据，您是否返回上一级~', '温馨提示', {
                    type: 'warning'
                }).then(res => {
                    this.$router.replace({
                        path: "/manage/exam/create-exam",
                        query: {
                            currentStep: 2
                        }
                    })
                })
            } else {
                this.$router.go(-1)
            }
        },
        uuid,
        addNewType() {
            this.typeList.push({
                RankNum: ++this.RankNum,
                Content: "新题型",
                SubScore: 0,
                TotalScore: 0,
                SubjectNum: 0,
                uuid: this.uuid(),
                SubjectList: []
            });
            this.$nextTick(() => {
                this.scrollTo(this.typeList.length - 1)
            })
        },
        save () {
            const type = this.$route.query.type
            if (type === "quickExam") {
                this.$confirm('试卷是否修改完成，并另存为新试卷', '温馨提示', {
                    type: "warning"
                }).then(res => {
                    this.goSave((id) => {
                        this.$router.replace({
                            path: "/manage/exam/create-exam",
                            query: {
                                paperId: id,
                                currentStep: 2
                            }
                        })
                    })
                })
            } else {
                this.goSave((id) => {
                    this.$router.replace({
                        path: "/manage/resource/paper"
                    })
                })
            }
        },
        handleBack () {
            const type = this.$route.query.type
            this.$confirm('返回上一级将不保留该页面数据，您是否返回上一级~', '温馨提示', {
                type: 'warning'
            }).then(() => {
                if (type === "quickExam") {
                    this.$router.push({
                        path: "/manage/exam/create-exam",
                        query: {
                            currentStep: 2
                        }
                    })
                } else {
                    this.$router.go(-1)
                }
            })
        },
        scrollTo(index) {
            let target = document.querySelector("#zj-add-exam-type-box" + index)
            scrollTop(this.$refs['zj-add-exam-paper'], target)
        },
        goSave(event = () => {}) {
            this.typeList.forEach((res) => {
                res.SubjectList.forEach((q, index) => {
                    q.RankNum = index + 1
                    if (q.ClassId == null || q.ClassId === 0) {
                        q.ClassId = this.paperInfo.type
                    }
                    if (q.UseType == null || q.UseType === 0) {
                        q.UseType = this.paperInfo.useFor
                    }
                    if (q.SubjectType === SubjectType.multiple && Array.isArray(q.Answer)) {
                        q.Answer = q.Answer.join("、")
                    }
                });
            });
            console.log(" this.typeList:", this.typeList);

            let message = this.checkError(this.typeList);
            // console.log("message:", message);
            if (message) {
                this.$message.warning(message);
                return;
            }
            this.flagPromise([
                createPaper({
                    examPaperModel: JSON.stringify({
                        ExamName: this.paperInfo.name,
                        ClassId: this.paperInfo.type,
                        ExamUse: this.paperInfo.useFor,
                        Authority: this.paperInfo.privilege,
                        PassScore: this.paperInfo.passScore,
                        TotalScore: this.paperInfo.totalScore,
                        SubjectNum: this.paperInfo.subjectNum,
                        SubjectTypeList: this.typeList
                    })
                })
            ])
                .then(([res]) => {
                    console.log(res, "addPaper")
                    this.$message.success("创建成功");
                    this.resetForm();
                    event(res);
                })
                .catch((e) => {
                    // console.log("e:", e);
                    // this.$message.warning(e.msg);
                });
        },
        // 重置表单
        resetForm() {
            this.paperInfo = {
                name: "",
                type: this.paperInfo.type,
                useFor: 1,
                totalScore: null,
                passScore: null,
                privilege: 1
            }
            this.typeList = []
        },
        deleteType(index) {
            this.typeList.splice(index, 1);
        },
        changePosition([ty, pos]) {
            const index = this.typeList.findIndex(
                (item) => item.RankNum === ty.RankNum
            );
            console.log(ty, "index");
            console.log(this.typeList, "this.typeList");
            if (pos === "behind") {
                console.log("向后");
                if (index === this.typeList.length - 1) {
                    this.$message.warning("已经是最后一个试题模块了");
                } else {
                    const behind = JSON.parse(JSON.stringify(this.typeList[index + 1]))
                    // behind.RankNum = index
                    const previousVal = JSON.parse(JSON.stringify(this.typeList[index]))
                    // previousVal.RankNum = index + 1
                    this.$set(this.typeList, index, behind)
                    this.$set(this.typeList, index + 1, previousVal)
                }
                // this.goBehind(ty, index);
            }
            if (pos === "ahead") {
                if (index === 0) {
                    this.$message.warning("已经是第一个试题模块了");
                } else {
                    const ahead = JSON.parse(JSON.stringify(this.typeList[index - 1]))
                    // ahead.RankNum = index
                    const previousVal = JSON.parse(JSON.stringify(this.typeList[index]))
                    // previousVal.RankNum = index - 1
                    this.$set(this.typeList, index - 1, previousVal)
                    this.$set(this.typeList, index, ahead)
                }
                // this.goAhead(ty, index);
                console.log("向前");
            }
        },
        goBehind(item, index) {
            const tIndex = index;

            if (tIndex === this.typeList.length - 1) {
                this.$message.warning("已经是最后一个试题模块了");
                return;
            }
            const lastPositionType = this.typeList[tIndex + 1];
            // console.log("lastPositionQ:", lastPositionQ);
            this.typeList[tIndex + 1] = {
                ...item,
                RankNum: tIndex + 2
            };
            this.typeList[tIndex] = {
                ...lastPositionType,
                RankNum: tIndex + 1
            };
            this.keyIndex += 1;

            this.typeList = Array.from(this.typeList)
            // console.log("typeList:", this.typeList);
        },
        goAhead(item, index) {
            const tIndex = index;
            if (tIndex === 0) {
                this.$message.warning("已经是第一个试题模块了");
                return;
            }
            const aheadPositionType = this.typeList[tIndex - 1];
            this.typeList[tIndex - 1] = {
                ...item,
                RankNum: tIndex
            };
            this.typeList[tIndex] = {
                ...aheadPositionType,
                RankNum: tIndex + 1
            };
            this.keyIndex += 1;
            this.typeList = Array.from(this.typeList)
            // console.log("typeList:", this.typeList);
        },
        checkError(typeList) {
            console.log("typeList:", typeList);
            let message;
            for (let i = 0; i < typeList.length; i++) {
                const item = typeList[i];
                if (!item.Content) {
                    message = "请输入模块名称";
                    break;
                }
                let hasQues = item.SubjectList && item.SubjectList.length > 0
                let hasRule = item.RandomSubjectList && item.RandomSubjectList.length > 0
                if (!hasQues && !hasRule) {
                    message = "请添加试题";
                    break;
                }
                if (hasQues) {
                    const isFill = item.SubjectList.every((q) => q.Score);
                    if (!isFill) message = "请输入试题分数";
                }
                if (hasRule) {
                    const isFill = item.RandomSubjectList.every(q => q.SubScore)
                    if (!isFill) message = "请输入组卷试题分数";
                }
            }
            return message;
        },
        updateOrganClass(list) {
            this.organClass.length = 0
            this.organClass.push(...list)
        }
    }
};
</script>

<style lang="less" scoped>
.exam-paper {
    height: calc(100vh - 0.83333rem);
    overflow-y: scroll;
    position: relative;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #d5d5d5;;
    }

    .e-condition ::v-deep {
        padding: 0 30px;

        .item {
            margin-top: 30px;
            margin-right: 10px;

            .name {
                white-space: nowrap;
                width: 4em;
                font-size: 16px;
                text-align: right;
                padding-right: 8px;
            }
        }

        .el-input {
            width: 210px;
            height: 34px;

            input {
                height: 34px;

                ::placeholder {
                    font-size: 16px;
                }
            }
        }
    }

    .e-paper {
        margin: 60px 0 30px;
        padding: 0 30px;

        .que-type {
            position: sticky;
            top: 20px;
            width: 270px;
            margin-right: 10px;
            max-height: calc(100vh - 1rem - 100px);
            overflow-y: auto;
            border: 1px solid #e5e8ec;

            &::-webkit-scrollbar {
                width: 6px;
                background: #f4f5f6;;
            }

            &::-webkit-scrollbar-thumb {
                background: grey;
            }

            .add-new-type {
                position: sticky;
                top: 0;
                height: 60px;
                background: #f4f5f6;
                z-index: 1;

                .el-button {
                    height: 36px;
                    width: 120px;
                    border-radius: 4px;
                    padding: 0;
                }
            }

            .added-tp {
                padding: 20px 20px 0;
            }
        }

        .border {
            border: 1px solid #e5e8ec;
            min-height: 200px;
        }
    }

    .bottom-btn {
        margin: 40px 0 27px;

        & > .el-button {
            border-radius: 4px;
            padding: 0;
            height: 34px;
        }

        & > .el-button:nth-of-type(1) {
            width: 120px;
        }

        & > .el-button:nth-of-type(2),
        .el-button:nth-of-type(3) {
            width: 80px;
        }
    }

    .return {
        z-index: 10;
        color: #969799;
        position: absolute;
        top: 0.05rem;
        left: 0.1rem;
    }
}
.step {
    font-size: 13px;
    position: relative;
    color: #2F3134;
    padding: 0 30px;
    &::before {
        content: attr(data-number);
        display: inline-block;
        height: 18px;
        width: 18px;
        border-radius: 50%;
        line-height: 20px;
        color: #FFFFFF;
        text-align: center;
        margin-right: 4px;
        background: #256CF4;
    }
}
</style>
